import { Building2, UserCog, Layers } from "lucide-react";
import { useTranslation } from "../../../../i18n/useTranslation";

const MarketProfile = ({ tag, name, intro, offices, officesTitle, leadershipLabel, ceo, ceoLinkedIn, solutionsNote }) => {
  const { t } = useTranslation();
  const resolvedSolutionsNote = solutionsNote || "iTrust.ID · DeviceWorks";

  const cards = [
    {
      key: "offices",
      Icon: Building2,
      title: officesTitle || (offices.length > 1 ? t("marketProfile.offices") : t("marketProfile.headquarters")),
      body: offices.map((o) => (
        <p key={o.label} className="mini">
          {o.label ? <strong>{o.label}: </strong> : null}{o.address}
        </p>
      )),
    },
    ceo
      ? {
          key: "leadership",
          Icon: UserCog,
          title: leadershipLabel || t("marketProfile.localLeadership"),
          body: (
            <>
              <p className="mini">{ceo}</p>
              {ceoLinkedIn && (
                <a href={ceoLinkedIn} target="_blank" rel="noreferrer" className="mini" style={{ color: "var(--gold)" }}>
                  LinkedIn ↗
                </a>
              )}
            </>
          ),
        }
      : null,
    {
      key: "solutions",
      Icon: Layers,
      title: t("marketProfile.solutionsTitle"),
      body: <p className="mini">{resolvedSolutionsNote}</p>,
    },
  ].filter(Boolean);

  const gridCols = cards.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3";

  return (
    <div>
      <div className="band-hero section text-center">
        <span className="tag-verdigris">{tag}</span>
        <h1 className="pt-2">{name}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{intro}</p>
        </div>
      </div>

      <div className="band-a section-tight">
        <div className={`max-w-4xl mx-auto grid grid-cols-1 ${gridCols} gap-6 px-5`}>
          {cards.map(({ key, Icon, title, body }) => (
            <div key={key} className="card-ledger text-center">
              <Icon className="mx-auto" size={36} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <h4 className="pt-2">{title}</h4>
              {body}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketProfile;
